export const ONION_4_SEQUENCE = [
  "onion4_clean",
  "onion4_half",
  "onion4_mandu",
  "onion4_study",
  "onion4_white",
];

export function getNextUnlockOnion(unlocked: string[]) {
  return ONION_4_SEQUENCE.find(o => !unlocked.includes(o)) ?? null;
}
